import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE } from "../constants/actionTypes";

const INITIAL_STATE = {
  fetching: null,
  error: null,
  isLoggedIn: null,
  universityFirebase: "ThammasatUniversity"
};

const loginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null,
        universityFirebase: null
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        isLoggedIn: true,
        universityFirebase: action.universityFirebase
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
        isLoggedIn: false,
        universityFirebase: null
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        isLoggedIn: false,
        universityFirebase: null
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default loginReducer;



// WEBPACK FOOTER //
// /src/reducers/authReducer.js